<template>
    <b-input-group>
      <b-form-input
        v-model="textValue"
        :disabled="realDisabled"
        :placeholder="placeholder"
      />
      <b-input-group-append v-if="confirmButtons" class="transparent">
        <b-btn
          v-if="realDisabled"
          :disabled="!editDisabled"
          @click="enableEditing"
          class="edit-button"
        >
          <font-awesome-icon
            :icon="['far', 'pencil']"
            size="sm"
          />
        </b-btn>
        <b-btn
          v-if="!realDisabled && !loading"
          @click="onConfirm"
          class="edit-button"
        >
          <font-awesome-icon
            :icon="['fal', 'check']"
            class="green"
            size="sm"
          />
        </b-btn>
        <b-btn
          v-if="!realDisabled && !loading"
          @click="onCancel"
          class="edit-button"
        >
          <font-awesome-icon
            :icon="['far', 'times']"
            class="red"
            size="sm"
          />
        </b-btn>
        <b-btn
          v-if="loading"
          class="edit-button"
        >
          <font-awesome-icon
            :icon="['fal', 'spinner']"
            size="sm"
            spin
          />
        </b-btn>
      </b-input-group-append>
    </b-input-group>
  </template>

  <script>
  export default {
    name: 'text-field',
    props: {
      value: {
        type: String,
        default: '',
      },
      confirmButtons: {
        type: Boolean,
        default: true,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        realDisabled: true,
        textValue: this.value,
        originalText: this.value,
        editDisabled: this.canEditWorkOrder(),
      };
    },
    watch: {
      value(newValue) {
        this.textValue = newValue;
        this.originalText = newValue;
      },
      disabled(newDisabled) {
        this.realDisabled = newDisabled;
      },
    },
    methods: {
      enableEditing() {
        this.realDisabled = false;
      },
      onConfirm() {
        this.$emit('input', this.textValue);
        this.$emit('confirm', this.textValue);
        this.realDisabled = true;
      },
      onCancel() {
        this.textValue = this.originalText;
        this.realDisabled = true;
        this.$emit('cancel');
      },
      canEditWorkOrder() {
        return this.$can(this.$perm.ACTIONS_EDIT_WORK_ORDERS, this.$perm.PERMISSION_TYPE_ACTION);
      }
    },
  };
  </script>

